const cbr250rrData = {
  slug: "cbr250rr",
  name: "Honda CBR250RR",

  hero: {
    shortDescription:
      "Motor sport supersport 250cc 2-silinder dengan performa tinggi, teknologi balap, dan desain agresif",

    variants: [
      {
        key: "std-black",
        label: "STD",
        fullName: "Honda New CBR 250RR STD Black Freedom",
        startPrice: 67179000,
      },
      {
        key: "std-gunpowder",
        label: "STD",
        fullName:
          "Honda New CBR 250RR STD Mat Gunpowder Black Metallic",
        startPrice: 71979000,
      },
      {
        key: "sp-blue",
        label: "SP",
        fullName: "Honda New CBR 250RR SP Mystique Blue",
        startPrice: 79115000,
      },
      {
        key: "spqs-red-black",
        label: "SP QS",
        fullName:
          "Honda New CBR 250RR SP QS Bravery Red Black",
        startPrice: 83165000,
      },
      {
        key: "spqs-red",
        label: "SP QS",
        fullName:
          "Honda New CBR 250RR SP QS Racing Red",
        startPrice: 83764000,
      },
      {
        key: "spqs-tricolor",
        label: "SP QS",
        fullName:
          "Honda New CBR 250RR SP QS Tricolor",
        startPrice: 83764000,
      },
    ],

    slides: [
      {
        variantKey: "std-black",
        image: "/assets/motor/produk/cbr250rr/Honda-New-CBR-250RR-STD-Black-Freedom-1.webp",
        specs: {
          engine:
            "249,7 cc, 4 Langkah, DOHC, 8 Katup, 2 Silinder",
          power: "31 kW (42 PS) / 13.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "std-gunpowder",
        image: "/assets/motor/produk/cbr250rr/Honda-New-CBR-250RR-STD-Mat-Gunpowder-Black-Metallic-1.webp",
        specs: {
          engine:
            "249,7 cc, 4 Langkah, DOHC, 8 Katup, 2 Silinder",
          power: "31 kW (42 PS) / 13.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "sp-blue",
        image: "/assets/motor/produk/cbr250rr/Honda-New-CBR-250RR-SP-Mystique-Blue.webp",
        specs: {
          engine:
            "249,7 cc, 4 Langkah, DOHC, 8 Katup, 2 Silinder",
          power: "31 kW (42 PS) / 13.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "spqs-red-black",
        image: "/assets/motor/produk/cbr250rr/Honda-New-CBR-250RR-SP-QS-Bravery-Red-Black.webp",
        specs: {
          engine:
            "249,7 cc, 4 Langkah, DOHC, 8 Katup, 2 Silinder, Pendingin Cairan",
          power: "31 kW (42 PS) / 13.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "spqs-red",
        image: "/assets/motor/produk/cbr250rr/Honda-New-CBR-250RR-SP-QS-Racing-Red.webp",
        specs: {
          engine:
            "249,7 cc, 4 Langkah, DOHC, 8 Katup, 2 Silinder, Pendingin Cairan",
          power: "31 kW (42 PS) / 13.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "spqs-tricolor",
        image: "/assets/motor/produk/cbr250rr/Honda-New-CBR-250RR-SP-QS-Tricolor.webp",
        specs: {
          engine:
            "249,7 cc, 4 Langkah, DOHC, 8 Katup, 2 Silinder, Pendingin Cairan",
          power: "31 kW (42 PS) / 13.000 rpm",
          smartKey: true,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda CBR250RR merupakan motor sport supersport kelas 250cc yang mengusung teknologi balap Honda dengan mesin 2-silinder berperforma tinggi.",
      },
      {
        type: "paragraph",
        text:
          "Ditenagai mesin 250cc DOHC 8 katup 2 silinder, CBR250RR mampu menghasilkan tenaga hingga 42 PS, menjadikannya salah satu motor 250cc paling bertenaga di kelasnya.",
      },
      {
        type: "heading",
        text: "Desain Supersport Agresif",
      },
      {
        type: "paragraph",
        text:
          "Desain aerodinamis dengan fairing tajam, lampu depan dual LED, serta bodi kompak memberikan karakter balap yang kuat dan modern.",
      },
      {
        type: "heading",
        text: "Teknologi Balap Honda",
      },
      {
        type: "paragraph",
        text:
          "Dilengkapi Throttle By Wire, 3 Riding Mode, Quick Shifter (tipe SP QS), Assist & Slipper Clutch, serta ABS dual channel untuk performa dan keamanan maksimal.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      [
        "Tipe Mesin",
        "4 Langkah, DOHC, 8 Katup, 2 Silinder, Pendingin Cairan",
      ],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "249,7 cc"],
      ["Daya Maksimum", "31 kW (42 PS) / 13.000 rpm"],
      ["Torsi Maksimum", "25 Nm / 11.000 rpm"],
      ["Transmisi", "Manual, 6 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Diamond Steel Frame"],
      ["Suspensi Depan", "Upside Down (USD) Showa SFF-BP"],
      ["Suspensi Belakang", "Pro-Link Monoshock"],
      ["Rem Depan", "Cakram Ganda dengan ABS"],
      ["Rem Belakang", "Cakram dengan ABS"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "2.060 x 724 x 1.098 mm"],
      ["Tinggi Jok", "790 mm"],
      ["Jarak Sumbu Roda", "1.389 mm"],
      ["Berat", "168–170 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "14,5 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda CBR250RR",
    items: [
      {
        title: "Mesin 250cc 2-Silinder DOHC",
        desc:
          "Mesin performa tinggi dengan tenaga hingga 42 PS untuk pengalaman berkendara ala motor balap.",
      },
      {
        title: "Throttle By Wire & Riding Mode",
        desc:
          "Tiga mode berkendara (Comfort, Sport, Sport+) untuk menyesuaikan karakter mesin.",
      },
      {
        title: "Quick Shifter",
        desc:
          "Perpindahan gigi tanpa kopling untuk akselerasi lebih cepat. *Tersedia pada tipe SP QS.",
      },
      {
        title: "Assist & Slipper Clutch",
        desc:
          "Menjaga stabilitas roda belakang saat deselerasi agresif.",
      },
      {
        title: "Dual Channel ABS",
        desc:
          "Sistem pengereman ABS depan dan belakang untuk keamanan maksimal.",
      },
      {
        title: "Upside Down Suspension",
        desc:
          "Suspensi depan USD Showa SFF-BP untuk handling presisi dan stabil.",
      },
      {
        title: "Full LED Lighting System",
        desc:
          "Pencahayaan full LED dengan tampilan agresif dan modern.",
      },
      {
        title: "Panel Meter Full Digital",
        desc:
          "Panel meter digital canggih dengan informasi lengkap gaya balap.",
      },
    ],
  },
};

export default cbr250rrData;
